import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { initSentry } from './sentry'
import App from './App.jsx'
import './styles/index.css'

// Init error monitoring до рендера React — чтобы ловить ошибки даже
// в самом раннем mount-цикле. No-op в dev режиме.
initSentry()

// Vite emits 'vite:preloadError' when a lazy chunk fails to load (typically a
// stale tab after a deploy — old index.html points at hashed chunks that are now
// 404). Reload once to fetch the fresh bundle, BEFORE React tries to render the
// lazy route (catches it earlier than ChunkErrorBoundary). sessionStorage throttle
// guards against a reload loop on a genuinely-offline client.
window.addEventListener('vite:preloadError', (event) => {
  // Share the 'chunk_reload' throttle key with ChunkErrorBoundary (App.jsx) so the
  // two reload paths cooperate — a recent preload-triggered reload suppresses a
  // follow-up boundary reload within the 30s window (no double-reload).
  const KEY = 'chunk_reload'
  const last = sessionStorage.getItem(KEY)
  if (!last || Date.now() - Number(last) > 30000) {
    sessionStorage.setItem(KEY, String(Date.now()))
    event.preventDefault() // stop Vite's rethrow → avoids duplicate Sentry noise
    window.location.reload()
  }
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#18181b',
            color: '#fafafa',
            border: '1px solid #27272a',
            borderRadius: '12px',
            padding: '12px 16px',
            fontSize: '13px',
            fontWeight: 500,
            boxShadow: '0 8px 30px rgba(0,0,0,0.4)',
            maxWidth: '380px',
          },
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#97D700',
              secondary: '#18181b',
            },
          },
          error: {
            duration: 5000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#18181b',
            },
          },
          loading: {
            iconTheme: {
              primary: '#a1a1aa',
              secondary: '#18181b',
            },
          },
        }}
      />
    </BrowserRouter>
  </React.StrictMode>,
)